<div class="custom-mat-dialog-form">
    <button mat-icon-button class="cross-button" [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>

    <div style="justify-content: space-between; display: flex; align-items: center;">
        <div class="popup-header">
            <h3>{{title}}</h3>
        </div>

        <div class="space-left" style="margin-left:600px; margin-right:15px;">
            <mat-form-field class="search-input max-30w" style="width: 25vw;">
                <input placeholder="Filter"
                    matInput
                    (keyup)="applyFilter($event)">
            </mat-form-field>
        </div>
    </div>

    <div class="popup-table-container">
        <table mat-table
           [dataSource]="dataSource"
           multiTemplateDataRows
           matSort
           class="mat-elevation-z8 mat-table-custom" id="branchhierarchylogshistorypopuplist">

        <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.Action"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="MgmtBranch">
            <th mat-header-cell *matHeaderCellDef> MgmtBranch </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.MgmtBranch"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="Region">
            <th mat-header-cell *matHeaderCellDef> Region </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.Region"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="District">
            <th mat-header-cell *matHeaderCellDef> District </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.District"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="Branch">
            <th mat-header-cell *matHeaderCellDef> Branch </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.Branch"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="Number">
            <th mat-header-cell *matHeaderCellDef> Number </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.Number"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="Key">
            <th mat-header-cell *matHeaderCellDef> Key </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.Key"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="TimeZone">
            <th mat-header-cell *matHeaderCellDef> Time Zone </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.TimeZone"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="ChangedBy">
            <th mat-header-cell *matHeaderCellDef> Changed By </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.ChangedBy"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="ChangedAtUtc">
            <th mat-header-cell *matHeaderCellDef> Changed At (UTC) </th>
            <td mat-cell *matCellDef="let element">
                <p>{{element.ChangedAtUtc | date:'yyyy-MM-dd HH:mm'}}</p>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="opmode-item"></tr>

        </table>
    </div>
</div>
